import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LoginService } from '../../login/LoginService';
import { ToastService } from '../../../AppToast';
import { AppStorage } from '../../../service/UserStorage';
type EmailProps = {
  setDisplayDone?: (display: boolean) => void;
};

export default function Email({ setDisplayDone }: EmailProps) {
  const [submitted, setSubmitted] = useState(false);
  const [value, setValue] = useState({
    taxCode: '',
    email: '',
  });

  const [error, setError] = useState({
    taxCode: '',
    email: '',
  });
  const validateTaxCode = (value) => {
    let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
    if (value.length > 10) {
      patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
    }
    const cccdRegex = /^[0-9]{3}[0-5]\d{2}\d{6}$/;
    if (value === "") return true;

    // Kiểm tra nếu là căn cước công dân (12 ký tự)
    if (value.length === 12) {
      return cccdRegex.test(value);
    }

    // Kiểm tra mã số thuế
    if (patt.test(value) === false) {
      return false;
    }
    const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
      + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
      + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

    return (10 - number % 11) === Number(value.charAt(9));
  };

  useEffect(() => {
    document.documentElement.style.fontSize = '14px';
    if (AppStorage.get('tenantName')) {
      setValue({ ...value, taxCode: AppStorage.get('tenantName') });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const handleChange = (event) => {
    const { name, value } = event.target;
    setValue((val) => ({
      ...val,
      [name]: value,
    }));
  };
  const validate = () => {
    let valid = true;
    for (const key in value) {
      if (!value[key]) {
        setError((err) => ({ ...err, [key]: 'không được để trống' }));
        valid = false;
      } else {
        setError((err) => ({ ...err, [key]: '' }));
      }
      if (key === 'taxCode' && value[key] && !validateTaxCode(value.taxCode)) {
        setError((err) => ({ ...err, [key]: ' không đúng định dạng' }));
        valid = false;
      }
      if (key === 'email' && value[key] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value[key])) {
        setError((err) => ({ ...err, [key]: ' không đúng định dạng' }));
        valid = false;
      }
    }

    return valid;
  };

  const handleSubmit = (event) => {
    if (!submitted && validate()) {
      setSubmitted(true);
      LoginService.forgotPassword(value.email, value.taxCode)
        .then(() => {
          setSubmitted(false);
          setDisplayDone(true);
        })
        .finally(() => {
          setSubmitted(false);
        });
    }
    event.preventDefault();
  };

  return (
    <>
      <p className="text-center text-lg mb-4">Vui lòng nhập mã số thuế và email để lấy lại mật khẩu </p>

      <form onSubmit={handleSubmit} className="p-fluid p-2">
        <div className="mb-3">
          <label htmlFor="taxCode" className="block text-900 font-medium mb-2">
            Mã số thuế
            <span className="required">*</span>
          </label>
          <InputText id="taxCode" name="taxCode" type="text" value={value.taxCode} onChange={(e) => handleChange(e)} />
          {error.taxCode && <small className="p-error">{`Mã số thuế ${error.taxCode}`}</small>}
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="block text-900 font-medium mb-2">
            Email
            <span className="required">*</span>
          </label>
          <InputText id="email" name="email" type="text" value={value.email} onChange={(e) => handleChange(e)} />
          {error.email && <small className="p-error">{`Email ${error.email}`}</small>}
        </div>
        <Button label="Lấy lại mật khẩu" className="w-full p-button-success" disabled={submitted} />

        <div className="text-center mt-3">
          <Link to="/login">
            <span className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">Quay lại đăng nhập</span>
          </Link>
        </div>
      </form>
    </>
  );
}
